export default state => state.restrictionEnzymes.filteredRestrictionEnzymes;
